import axios from 'axios'

export default defineNuxtRouteMiddleware((to, from) => {
    const config = useRuntimeConfig()
    const baseUrl = config.public.HOMEDELI_API_BASE_URL

    return new Promise((resolve, reject) => {
        axios.post(`${baseUrl}/access-register`, { path: to.path })
            .then(() => {
                resolve(true)
            })
            .catch(() => {
                reject(false)
            })
    })
})
